// @Version: 1.0.0
import { DATEFORMAT, DATEFORMATCALENDER } from "./date.model";

export class DateFormatConfig {
   public format: DATEFORMATCALENDER = DATEFORMATCALENDER.DATE;

   get parse () {
      switch (this.format) {
         case DATEFORMATCALENDER.DATE: return { dateInput: DATEFORMAT.DE };
         case DATEFORMATCALENDER.MONTHYEAR: return { dateInput: [DATEFORMAT.MONTH_YEAR, DATEFORMAT.DE] };
         case DATEFORMATCALENDER.YEAR: return { dateInput: [DATEFORMAT.YEAR, DATEFORMAT.MONTH_YEAR, DATEFORMAT.DE] };
         default: return { dateInput: DATEFORMAT.DE }
      }
   }

   get display () {
      switch (this.format) {
         case DATEFORMATCALENDER.DATE: return this.setFormat(DATEFORMAT.DE, DATEFORMAT.LABEL_MONTH_YEAR, DATEFORMAT.DATE_A11_LABEL, DATEFORMAT.MONTH_YEAR_A11Y_LABEL); 
         case DATEFORMATCALENDER.MONTHYEAR: return this.setFormat(DATEFORMAT.MONTH_YEAR, DATEFORMAT.LABEL_MONTH_YEAR, DATEFORMAT.DATE_A11_LABEL, DATEFORMAT.MONTH_YEAR_A11Y_LABEL); 
         case DATEFORMATCALENDER.YEAR: return this.setFormat(DATEFORMAT.YEAR, DATEFORMAT.LABEL_MONTH_YEAR, DATEFORMAT.DATE_A11_LABEL, DATEFORMAT.MONTH_YEAR_A11Y_LABEL);
         default: return this.setFormat(DATEFORMAT.DE, DATEFORMAT.LABEL_MONTH_YEAR, DATEFORMAT.DATE_A11_LABEL, DATEFORMAT.MONTH_YEAR_A11Y_LABEL); 
      }
   }
   
   constructor () {}
   
   private setFormat (dateInput: string, monthYearLabel: string, dateA11yLabel: string, monthYearA11yLabel: string): Object {
      return {
         dateInput: dateInput,
         monthYearLabel: monthYearLabel,
         dateA11yLabel: dateA11yLabel,
         monthYearA11yLabel: monthYearA11yLabel,
      }
   }
}